import { Box } from '@mui/material'
import classNames from 'classnames/bind'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { logEventUserApi } from '~/apis/logEventUser'
import { baseLanguages, languageDesc } from '~/constants'
import STORAGE_KEYS from '~/constants/localStorage'
import { USER_ACTIONS } from '~/constants/logEventUser'
import { selectRestaurant } from '~/redux/restaurantSlice'
import { getParentType } from '~/utils/logEventUser'
import styles from './PopupLanguageTablet.module.scss'

const cx = classNames.bind(styles)

// Lựa chọn language
const PopupLanguageTablet = ({ onClosePopup }) => {
  const {
    supportLang = [],

    merchant_type,
    food_court_id,
    restaurantId,
    tableId,
  } = useSelector(selectRestaurant)
  const { i18n, t } = useTranslation()
  const i18nLanguage = i18n.language
  const [currentLanguage, setCurrentLanguage] = useState(i18nLanguage)

  const supportedLang = supportLang.map((langCode) => {
    return baseLanguages.find((lang) => lang.code === langCode)
  })
  /**
   * Xử lý check trường hợp ngôn ngữ trước đó không match với danh sách ngôn ngữ support
   * => lấy ngôn ngữ đầu tiên mà api trả về
   *  */
  useEffect(() => {
    if (!supportLang.includes(i18nLanguage)) {
      if (supportLang.length > 0) i18n.changeLanguage(supportLang[0])
    }
  }, [i18nLanguage, supportLang, i18n])

  useEffect(() => {
    setCurrentLanguage(i18nLanguage)
  }, [i18nLanguage])

  const handleLogEventUser = async () => {
    const localeFromLocal = localStorage.getItem(STORAGE_KEYS.LOCALE)

    // Nếu trước đó đã chọn ngôn ngữ -> không log
    if (localeFromLocal) return

    await logEventUserApi({
      parent_type: getParentType(merchant_type, food_court_id),
      parent_id: Number(food_court_id) || restaurantId,
      child_type: null,
      child_id: null,
      locale: currentLanguage,
      position_id: tableId || null,
      action: USER_ACTIONS.scan_qrcode,
    })
  }

  /**
   * Trường hợp đã nhập -> đóng popup và lưu locale vào storage
   */
  const handleConfirmLanguage = (currentLanguage) => {
    // Xử lý lưu log
    handleLogEventUser()
    localStorage.setItem(STORAGE_KEYS.LOCALE, currentLanguage) // đánh dấu là đã chọn ngôn ngữ rồi lần sau không mở popup nữa
    i18n.changeLanguage(currentLanguage) // chuyển ngôn ngữ i18n
  }

  // Hàm xử lý thay đổi language state
  const changeCurrentLanguage = (languageCode) => {
    setCurrentLanguage(languageCode)
    handleConfirmLanguage(languageCode)
    onClosePopup()
  }

  const renderLanguagesList = () => {
    return supportedLang.map((item) => {
      const Flag = item.image

      const active = currentLanguage === item.code

      return (
        <Box
          key={item.id}
          onClick={() => changeCurrentLanguage(item.code)}
          className={cx('item_language')}
          bgcolor="baseColor.color11"
          sx={{
            opacity: active ? 1 : 0.32,
          }}>
          <Box display="flex" borderRadius="4px">
            <Flag />
          </Box>
          <Box className={cx('name_language', 'txt_language')}>{item.name}</Box>
        </Box>
      )
    })
  }

  const renderContent = () => {
    const lgDesc = languageDesc[currentLanguage] || languageDesc['en']
    return <Box className={cx('content_wrapper', 'txt_desc')}>{lgDesc}</Box>
  }

  return (
    <Box className={cx('wrapper')}>
      <Box className={cx('languages_list')}>{renderLanguagesList()}</Box>
      {renderContent()}
    </Box>
  )
}

PopupLanguageTablet.propTypes = {
  setKeyPage: PropTypes.func,
  onClosePopup: PropTypes.func,
}

export default React.memo(PopupLanguageTablet)
